import Icon from '../icon/Icon'
import { useListingDecisions } from '../../_hooks/use-listing-decisions'
import { describeTag, nextTagInCycle, resolveTagTone } from './helpers'
import { ChipButton, Glyph } from './styled'
import { ListingTagChipProps } from './types'

/**
 * Single click-to-cycle chip for a listing's personal tag. State cycles
 * untagged → yes → maybe → no → untagged. Persists via
 * `listing-decisions-context` so it survives reloads and shows up
 * everywhere the chip is rendered.
 *
 * @param {ListingTagChipProps} props
 * @returns {JSX.Element}
 */
const ListingTagChip = ({
  listingId,
  size = 'md',
}: ListingTagChipProps): JSX.Element => {
  const { tags, setListingTag } = useListingDecisions()
  const currentTag = tags[listingId] ?? null
  const descriptor = describeTag(currentTag)
  const tone = resolveTagTone(currentTag)

  const handleClick = (event: {
    stopPropagation: () => void
    preventDefault: () => void
  }): void => {
    event.stopPropagation()
    event.preventDefault()
    setListingTag(listingId, nextTagInCycle(currentTag))
  }

  return (
    <ChipButton
      type="button"
      tone={tone}
      size={size}
      onClick={handleClick}
      aria-label={descriptor.ariaLabel}
    >
      <Glyph aria-hidden="true">
        <Icon icon={descriptor.glyph} />
      </Glyph>
      {descriptor.label}
    </ChipButton>
  )
}

export default ListingTagChip
